import { Popup, Burger, Mobile, Accordion, Carousel_CoreInit, Form_CoreInit, AjaxifyGrid_CoreInit } from './core'
import Dotdotdot from 'dotdotdot-js'
import './plugins/google-map'
import './plugins/post-share'
import './plugins/post-category-grid'
import './plugins/expandable-row'
import './plugins/same-height-rows'
import './plugins/quiz'

AjaxifyGrid_CoreInit([
  // {
  //   classSelector: 'grid--style--director',
  //   afterUpdate: function(grid) {
  //     $('.grid--style--director').GridSizer().do_resize()
  //     $.mlmi.navigation.registerLinks()
  //     $('.project-wrapper').each(function() {
  //       $(this).projectHover();
  //     })
  //   },
  // },
])

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--content',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1.325,
          spaceBetween: 120,
        }
      },
    },
  },
  {
    classSelector: 'carousel--style--history',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2.333,
        }
      },
    },
  },
])

Form_CoreInit()

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  $(window).on('resize load orientationchange', function() {
    header()
    $('body').css('--window-height', window.innerHeight + 'px')
  })

  /* Click to open menu */
  new Burger('.header__burger', {
    onToggle: function(burger) {
      if (burger.isExpanded) {
        $('body').addClass('--menu-open')
      } else {
        $('body').removeClass('--menu-open')
      }
    },
  })

  /* Click to anchor */
  $('main, .footer').find('a[href^="#"]').on('click', function(e) {
    let targetTop = -1
    if ($(this).attr('href') == '#top') {
      targetTop = 0
    } else if ($('a[name="' + $(this).attr('href').substring(1) + '"]').length) {
      targetTop = $('a[name="' + $(this).attr('href').substring(1) + '"]').offset().top
    } else if ($($(this).attr('href')).length) {
      targetTop = $($(this).attr('href')).offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 70)
    }
    if (targetTop !== -1) {
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      $(this).blur()
      return false
    }
  })

  //Sub menu anchors
  $('header').find('a[href*=#]').on('click', function(e) {
    if ($(this).attr('href').includes(window.location.host) || $(this).attr('href').substring(0, 1) == '/') {
    //internal
    var href = $(this).attr('href')
    var href_data = href.split("#");
      if (window.location.href.includes(href_data[0])) {
        //same page
        var targetTop = $('#' + href_data[1]).offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 70);
        $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        $(this).blur()
        history.replaceState(null, null, '#' + href_data[1]);
        return false
      }
    }
  })

  $('.toggle-expandable-row').each(function(index) {
    $(this).ExpandableRow(index)
  })

  $.fn.ReadMore = function(options) {
    let self = this

    if (self.data('read-more')) {
      return self.data('read-more')
    }

    self.options = $.fn.extend(true, {
      mobile: true,
      desktop: true,
      height: 80,
    }, options)

    self.button = undefined
    self.is_truncated = false
    self.dotdotdot = undefined

    self.toggled = function() {
      $(this).blur()
      if (self.is_truncated) {
        self.destroy()
        self.button = $('<button>' + fondationsaintlo_l10n.READ_LESS + '</button>').addClass('btn-plus')
        self.after(self.button)
        self.button.on('click', self.toggled)
        self.is_truncated = false
      } else {
        self.button.remove()
        self.button = undefined
        self.maybe_initialize()
      }
    }

    self.maybe_initialize = function() {
      if (self.dotdotdot == undefined) {
        self.dotdotdot = new Dotdotdot(self.get(0), {
          height: self.options.height,
          callback: function(isTruncated) {
            self.is_truncated = isTruncated
          }
        })
        self.button = $('<button>' + fondationsaintlo_l10n.READ_MORE + '</button>').addClass('btn-plus')
        self.after(self.button)
        self.button.on('click', self.toggled)
      }
    }

    self.destroy = function() {
      if (self.dotdotdot != undefined) {
        self.dotdotdot.API.destroy()
        self.dotdotdot = undefined
      }
      if (self.button != undefined) {
        self.button.remove()
        self.button = undefined
      }
    }

    self.mobile_toggled = function() {
      if ($.mlmi.mobile.isMobile) {
        if (self.options.mobile) {
          self.maybe_initialize()
        } else {
          self.destroy()
        }
      } else {
        if (self.options.desktop) {
          self.maybe_initialize()
        } else {
          self.destroy()
        }
      }
    }

    return function() {
      self.data('read-more', self)
      $.mlmi.mobile.add(self.mobile_toggled, self.mobile_toggled)
      return self
    }()
  }

  /* Dot dot dot */
  $('.card-history__description').each(function() {
    $(this).ReadMore({
      desktop: false,
    })
  })

  /* Détails */
  $('.details-link, .text-content .btn-plus, .btn-circle-plus, .btn-read-more').each(function() {
    let $link = $(this),
    $selection = $link.parent().nextUntil('hr', 'p,ul,ol,h1,h2,h3,blockquote,figure,div,table,form')
    $selection.wrapAll('<div class="text-content-wrapper"><div class="text-content">')
    let $wrapper = $link.parent().next()
    $wrapper.hide()
    if ($link.hasClass('btn-circle-plus') || ($link.hasClass('btn-plus') && !$link.hasClass('bg-blue'))) {
      $wrapper.after($link.parent())
    }
    $link.show().on('click', function() {
      $(this).blur()
      if ($wrapper.is(':visible')) {
        $wrapper.slideUp({
          duration: 300,
          easing: 'easeInOutQuart',
        })
        $link.text($link.data('open')).attr('aria-expanded', 'false')
      } else {
        $wrapper.slideDown({
          duration: 300,
          easing: 'easeInOutQuart',
        })
        $link.text($link.data('close')).attr('aria-expanded', 'true')
      }
    })
  })

  $('.details-link, .text-content .btn-plus').each(function() {
    $(this).closest('p').addClass('--sources')
  })

  $('.col:not(.col-colored):not(.border) .text-content[class*=bg-]').each(function() {
    $(this).closest('.col').addClass('has-bg-color')
  })

  /* Accordion */
  let faqs = []
  $('.accordion--faq').each(function() {
    faqs.push([$(this).parent(), $(this).detach()])
  })
  Accordion.init()

  /* Popup messages */
  Popup.init()

  faqs.forEach(function(faq) {
    faq[0].append(faq[1])
  })
  $('.accordion--boxes, .accordion--faq').each(function() {
    let $accordion = $(this),
    $items = $accordion.find('.accordion-item'),
    half = Math.ceil($items.length / 2)
    $items.wrapAll('<div class="accordion-columns"></div>')
    $items.slice(0, half).wrapAll('<div class="accordion-columns__column"></div>')
    $items.slice(half).wrapAll('<div class="accordion-columns__column"></div>')
  })
  $('.accordion--boxes .accordion__panel + div > button').on('click', function() {
    $(this).closest('.accordion-item').find('.accordion__header').click()
  })
  $('.js-accordion--start-open').each(function() {
    let close_button = $('<button class="btn-plus bg-blue" title="' + fondationsaintlo_l10n.CLOSE + '">&nbsp;</button>')
    close_button.on('click', function() {
      $(this).closest('.js-accordion--start-open').find('.accordion__header').click()
    })
    $(this).find('.container:first').prepend(close_button)
  })

  /* Margin CTA fix */
  if ($('#cta-infolettre').length) {
    function positionCTAButton() {
      let button = $('#cta-infolettre .field__submit')
      button.css('top', '')
      if (!$.mlmi.mobile.isMobile) {
        let diff = $('#cta-infolettre').closest('.container-cta').find('.page-section').last().find('.btn-primary').offset().top - button.offset().top
        if (diff > 0) {
          button.css('top', diff + 'px')
        }
      }
    }
    $(window).on('load resize orientationchange', positionCTAButton)
    positionCTAButton()
  }

  /* Google Map */
  $('.google-maps__map').each(function() {
    $(this).ContactMap()
  })

  /* w-*col fix */
  function calculateClasses() {
    if (!$.mlmi.mobile.isMobile) {
      let $firstRow = $('.page-section .text-row:first'),
      $w3col = $('<div>').addClass('col col-12 col-md-3'),
      $w4col = $('<div>').addClass('col col-12 col-md-4'),
      $w5col = $('<div>').addClass('col col-12 col-md-5'),
      $w6col = $('<div>').addClass('col col-12 col-md-6'),
      $w12col = $('<div>').addClass('col col-12')
      $firstRow.append($w3col).append($w4col).append($w5col).append($w6col).append($w12col)
      $('html').css({
        '--w3col': $w3col.width() + 'px',
        '--w4col': $w4col.width() + 'px',
        '--w5col': $w5col.width() + 'px',
        '--w6col': $w6col.width() + 'px',
        '--w12col': $w12col.width() + 'px',
      })
      $w3col.remove()
      $w4col.remove()
      $w5col.remove()
      $w6col.remove()
      $w12col.remove()
    }
  }
  $(window).on('load resize orientationchange', calculateClasses)
  calculateClasses()

  /* Post share */
  $('button[aria-controls="post-share"]').each(function() {
    $(this).PostShare_Button()
  })

  /* Post share */
  $('.blog-post__share .post-share, .blog-category__sharing .post-share').each(function() {
    $(this).PostShare_Button()
  })

  /* Post category grid */
  $('.grid--col-2.grid--taxitem__blog-category').each(function() {
    $(this).PostCategoryGrid()
  })

  /* Circle block */
  $('.circle-block').unwrap('p').wrapInner('<span>')

  /* Experts */
  if ($('.grid--taxitem__blog-expert').length > 0 && window.location.hash != false) {
    if ($(window.location.hash).length > 0) {
      $(window.location.hash).closest('.js-accordion__item').find('.js-accordion__header').trigger('click')
    }
  }

  $('.col-colored:not(.col-md-12)').each(function() {
    $(this).SameHeightRows()
  })

  $('.quiz').each(function() {
    $(this).Quiz()
  })

  // scroll to anchor
  window.addEventListener('load', function () {
    if (window.location.hash) {
      setTimeout(function() {
        const targetHash = window.location.hash;
          var targetTop = $(targetHash).offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 70);
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      }, 200);
    }
  })


})
